var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSurface = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 24,
  height: 24
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "surface_svg__b"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#surface_svg__a",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("path", {
  id: "surface_svg__a",
  d: "M0 0h24v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#surface_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M-.001 0h24v24h-24z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m18.363 8.35 4.55 2.61q.138.079.25.19.112.112.192.25.079.136.12.289t.041.311-.041.311-.12.29-.192.249q-.112.111-.25.19l-9.422 5.405q-.17.097-.35.171-.181.075-.37.125t-.383.076q-.193.025-.389.025-.195 0-.39-.025-.193-.026-.382-.076t-.37-.125-.35-.171L1.084 13.04q-.137-.079-.249-.19-.112-.112-.192-.249-.079-.137-.12-.29t-.041-.31q0-.16.041-.312.041-.153.12-.29.08-.137.192-.248.112-.112.25-.19l9.422-5.405q.17-.098.35-.172.181-.074.37-.125.189-.05.383-.075.194-.026.389-.026.196 0 .39.026.193.025.382.075t.37.125.35.172zm-1.15.66 4.718 2.705q.077.044.121.12.045.077.045.165t-.045.165-.12.12l-8.938 5.127q-.113.065-.234.114-.12.05-.246.083-.126.034-.255.05-.13.018-.26.018t-.26-.017q-.129-.017-.255-.05-.125-.034-.246-.084-.12-.05-.234-.114l-8.937-5.126q-.077-.044-.121-.121Q1.9 12.089 1.9 12q0-.088.045-.165.044-.076.12-.12l8.938-5.127q.114-.064.234-.114t.246-.083q.126-.034.256-.05.129-.018.259-.018t.26.017q.129.017.255.05.126.034.246.084t.234.114zM12 7.06l-3.2 2.4h2.2v4.73h-2.5l3.5 2.5 3.5-2.5h-2.5V9.46h2.2z"
}))));
export default SvgSurface;